<template>
  <div class="mask">
    <div class="main_content">
      <img class="close" @click="cancel()"  src="static/images/close.png" />
      <div class="payitem">
        <div class="pay_title">
          <p class="pay_head">Century Games</p>
    <!--     <p class="nickname">1200rc</p>
          <p class="payid">ehrewk</p> -->
        </div>

        <div id="dropin" ></div>


      </div>
      <div class="loadimg" v-if="payis">
        <img class="load" src="static/images/load.gif" />
      </div>
      <div class="loadmask" v-if="loadingis">
        <img class="load" src="static/images/load.gif" />
        <p>Loading . . .</p>
      </div>
      <p class="pay_tips">
        <img src="../images/icon_adyen_tips.png" class="icon" alt=""> {{ $t('adyen.note') }}
      </p>
      <!-- <p class="pay_tips2">
        {{ $t('adyen.note2') }}
      </p> -->
    </div>
  </div>
</template>

<script>

  import { adyenLocaleMap } from '../../tool/constant';
  import {getorder,adyen_callback,adyen_payments_details} from '@/api/index.js'
  export default {
    name: 'ayden',
    props: ['payinfo','mount','user_id'],
    data() {
       return {
          payis:true,
          cg_request_id:'',
          provider_order_id:'',
          payment_methods:[],
          client_key:'',
          loadingis:false
       }
    },
    created(){
      // console.log(this.payinfo)
      // console.log(this.mount)
      // // Set a same-site cookie for first-party contexts
      // document.cookie = 'cookie1=value1; SameSite=Lax';
      // // Set a cross-site cookie for third-party contexts
      // document.cookie = 'cookie2=value2; SameSite=None; Secure';
    },
    mounted() {
      this.order()
      document.documentElement.style.overflow = 'hidden'
    },
    beforeDestroy() {
      document.documentElement.style.overflow = ''
    },
    methods:{
        order(){

          this.$parent.payment_log.report('web_payment_getorder_start');
          const params = {
            ...this.payinfo,
            user_id: this.user_id
          }
          const uid = window.localStorage.getItem(`web_shopper_uid_${this.payinfo.uid}`)
          if (uid) {
            params.web_shopper_uid = uid
          }

          getorder(params).then(res=>{
            //console.log(res)
            if(res.data.code == 1){
              this.cg_request_id = res.data.data.cg_request_id;
              this.provider_order_id = res.data.data.provider_order_id;
              sessionStorage.setItem('provider_order_id',res.data.data.provider_order_id)
              this.$parent.updateProviderOrderId(res.data.data.provider_order_id)
              this.client_key = res.data.data.client_key;
              this.payment_methods = res.data.data.payment_methods;

              // 缓存adyen uid
              if (res.data.data.web_shopper_uid) {
                window.localStorage.setItem(`web_shopper_uid_${this.payinfo.uid}`, res.data.data.web_shopper_uid)
              }

              this.$parent.payment_log.set_properties({
                cg_request_id:this.provider_order_id
              })
              this.$parent.payment_log.report('web_payment_getorder_success');

              this.$parent.payment_log.report('web_payment_sdkinit_start');
              this.ayden();
              this.payis = false;


              this.$rum.report('pay_sucess', {
                paystyle: 'ayden',
                type: 'getorder',
                response: res.data,
                prams: this.payinfo
              }, 1)
            }else{
              this.$parent.failpay("Order failed！");

              this.$parent.payment_log.report('web_payment_getorder_fail',{
                  code:3,
                  msg: res.data.msg?res.data.msg:'Order failed'
              })

              this.$rum.report('pay_err', {
                paystyle: 'ayden',
                type: 'getorder',
                response: res.data,
                prams: this.payinfo
              }, 3)
            }
          }).catch((error) => {
              console.log(error)
              this.payis = false;
              this.$parent.payment_log.report('web_payment_getorder_error',{
                  code:2,
                  msg: error
              })
          });
        },
        cancel(){
            this.$parent.cancelpay();
            this.$parent.payment_log.report('web_payment_userpay_cancel');
        },
        ayden(){
            const configuration = {
                paymentMethodsResponse: this.payment_methods,
                amount:this.mount,
                // paymentMethodsResponse: payment_methods,
                // amount:{value:9999,"currency": "USD"},
                clientKey: this.client_key,
                locale: adyenLocaleMap[this.$i18n.locale],
                environment: process.env.STY,//生产环境需要更改为"live"
                onSubmit: (state, dropin) => {
                  this.loadingis = true;
                  var obj = {
                    "state_data":JSON.stringify(state.data),
                    "provider_order_id": this.provider_order_id,
                    "user_id": this.user_id
                  };

                  this.$ta.track('tpp_call_payment', {
                    iap_product_id: this.payinfo.product_id,
                    payment_type: 'adyen',
                    type: 2,
                    amount: this.payinfo.amount,
                    currency: this.payinfo.currency,
                    // server_id: this.payinfo.user_extra_value
                  })


                  this.$parent.payment_log.report('web_payment_userpay_success');
                  this.$parent.payment_log.report('web_payment_verification_start');

                  // console.log(state)
                  // console.log(obj)

                  adyen_callback(obj).then(response => {
                    if (response.data.code == 1) {
                      //Drop-in会自动根据这里拿到的action来处理/payments接口的响应
                      if(response.data.data.action){
                        dropin.handleAction(response.data.data.action);
                      }else{
                        this.$parent.successpay(response.data.data);

                        this.$parent.payment_log.set_properties({
                          transaction_id:response.data.data.transaction_id?response.data.data.transaction_id:''
                        });
                        this.$parent.payment_log.report('web_payment_check_success');
                      }
                      this.loadingis = false;
                      this.$rum.report('pay_sucess', {
                        paystyle: 'ayden',
                        type: 'onSubmit',
                        response: response,
                        prams: obj
                      }, 1)
                    }else{
                      this.$parent.failpay(response.data);
                      this.loadingis = false;

                      this.$parent.payment_log.report('web_payment_check_fail',{
                        code:3,
                        msg: response.data.msg?response.data.msg:'adyen_callback failed'
                      });

                      this.$rum.report('pay_err', {
                        paystyle: 'ayden',
                        type: 'onSubmit',
                        response: response,
                        prams: obj
                      }, 3)
                    }
                  }).catch(error => {
                    console.log(error)
                    this.$parent.failpay(error);
                    this.loadingis = false;

                    this.$parent.payment_log.report('web_payment_check_error',{
                      code:2,
                      msg: error
                    });

                    this.$rum.errorReport(error);
                    throw Error(error);
                  });
                },
                onAdditionalDetails: (state, dropin) => {
                    var obj = {
                        "details": JSON.stringify(state.data),
                        "provider_order_id": this.provider_order_id,
                    }

                    this.$parent.payment_log.report('web_payment_checkAgain_start');

                    this.payis = true;

                    adyen_payments_details(obj).then(response => {

                      if (response.data.code == 1) {
                          this.$parent.successpay(response.data.data);

                          this.$parent.payment_log.set_properties({
                            transaction_id:response.data.data.transaction_id?response.data.data.transaction_id:''
                          });
                          this.$parent.payment_log.report('web_payment_checkAgain_success');

                          this.$rum.report('pay_sucess', {
                            paystyle: 'ayden',
                            type: 'onAdditionalDetails',
                            response: response,
                            prams: obj
                          }, 1)
                      } else {
                          this.$parent.failpay(response.data);

                          this.$parent.payment_log.report('web_payment_checkAgain_fail',{
                            code:3,
                            msg: response.data.msg?response.data.msg:'adyen_payments_details failed'
                          });

                          this.$rum.report('pay_err', {
                            paystyle: 'ayden',
                            type: 'onAdditionalDetails',
                            response: response,
                            prams: obj
                          }, 3)
                      }
                      this.loadingis = false;
                      this.payis = false;
                    }).catch(error => {
                        this.$parent.failpay(response.data);
                        this.loadingis = false;
                        this.payis = false;
                        this.$parent.payment_log.report('web_payment_checkAgain_error',{
                          code:2,
                          msg: error
                        });
                        this.$rum.errorReport(error)
                        throw Error(error);
                    });
                },
                onError:(error)=>{
                  this.$rum.report('pay_err', {
                    paystyle: 'ayden',
                    type: 'aydenerror',
                    response: error,
                    prams: {"provider_order_id": this.provider_order_id}
                  }, 3)
                  console.error('Failed to load Adyen Checkout SDK', error);
                  console.log(error);
                },
                paymentMethodsConfiguration: {
                  card: {
                    //决定是否需要隐藏持卡人姓名输入框
                    hasHolderName: false,
                    //决定持卡人姓名输入框是否必填
                    holderNameRequired: false,
                    //决定是否需要隐藏绑卡勾选框
                    // enableStoreDetails: true,
                    //若您在使用绑卡交易并且不需要买家输入CVC时(recurringProcessingModel=Subscription或UnscheduledCardOnFile)，您可将这里改成true来隐藏CVC输入栏，详情参考tokenization绑卡交易具体对接文档)
                    hideCVC: false,
                    //定义了前段展示的文案
                    name: 'Credit or debit card'
                  }
                }
            }
            //console.log(configuration)
            const checkout = new AdyenCheckout(configuration);
            const dropin =  checkout.create('dropin', {
                onReady: () => {
                  console.log('Adyen Checkout SDK is onReady');
                  this.$parent.payment_log.report('web_payment_sdkinit_success');
                  this.$parent.payment_log.report('web_payment_userpay_start');
                },
                onError:(error)=>{
                  this.$parent.payment_log.report('web_payment_sdkinit_fail',{
                      code:2,
                      msg: error
                  })
                  console.error('Failed to load Adyen Checkout SDK', error);
                  console.log(error);
                },
            })
            dropin.mount('#dropin');
            console.log(dropin)
        }

    },

  }
</script>

<style scoped>
.main_content{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* text-align: center; */
  max-width: 750px;
  width: 90%;
  background-color: #FFFFFF;
  padding: 16px;
  box-sizing: border-box;
  /* overflow: auto; */
}
.close{
    position: absolute;
    top: -2.4rem;
    right: 0;
    width: 1.875rem;
    height: 1.875rem;
    cursor: pointer;
  }
  .payitem{
    background-color: #FFFFFF;
    margin: 0 auto;
    max-height: 70vh;
    overflow-y: auto;
    position: relative;
  }
  .loadmask{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    padding-top: 3.75rem;
    top: 0;
    left: 0;
  }
  .loadmask p{
    color: #FFFFFF;
    font-size: 0.875rem;
    text-align: center;
  }
  .pay_title p{
    font-size:1rem;
    line-height:1.875rem;
    margin-bottom: 0.625rem;
    text-align: center;
  }
  .pay_head{
    font-family: "SemiBold";
    text-align: center;
  }
  .loadimg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #fff;
  }
  .pay_tips, .pay_tips2{
    padding-top: .6rem;
    font-size: .72rem;
    line-height: 1.2rem;
    /* text-align: left; */
    color: #666;

  }
  .pay_tips2{
    padding-top: 0;
    color: #4b5560;
  }
  .pay_tips .icon{
    width: 1rem;
    height: auto;
    vertical-align: middle;
  }
  @media (max-width: 1024px) {
    .payitem{
      max-height: 50vh;
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ayden.vue